<template>
  <v-app>
    <v-app-bar app flat color="grey lighten-4">
      <v-app-bar-nav-icon
        @click="drawer = !drawer"
        v-if="$route.path !== '/dashboard'"
      ></v-app-bar-nav-icon>
      <div v-else>GescoReports</div>
      <v-spacer></v-spacer>
      <user-profile />
    </v-app-bar>
    <v-navigation-drawer
      app
      v-model="drawer"
      overlay-opacity="0"
      v-if="$route.path !== '/dashboard'"
    >
      <template v-slot:prepend>
        <v-list-item
          two-line
          @click="
            $keycloak.hasResourceRole('admin', 'po-viewer') ||
            $keycloak.hasResourceRole('si', 'po-viewer') ||
            $keycloak.hasResourceRole('ecg', 'po-viewer')
              ? $route.path !== '/'
                ? $router.push('/')
                : null
              : $route.path !== '/service-communication'
              ? $router.push('/service-communication')
              : null
          "
        >
          <v-list-item-avatar tile>
            <img
              src="https://storage.googleapis.com/visual-identity/logo/2020-slim.svg"
              alt="Logo HEIG-VD"
            />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>BONS DE COMMANDE</v-list-item-title>
            <v-list-item-subtitle
              >Interface de consultation</v-list-item-subtitle
            >
          </v-list-item-content>
        </v-list-item>
      </template>
      <v-divider></v-divider>
      <v-list dense nav v-if="$keycloak.hasResourceRole('admin', 'po-viewer')">
        <v-subheader>CENTRES DE COÛT</v-subheader>
        <v-list-item
          v-for="costcenter in costcenters.filter((cc) =>
            $keycloak.hasResourceRole('si', 'po-viewer')
              ? cc.number === '00000'
              : true
          )"
          :key="costcenter._id"
          link
          :to="`/validations?costcenter=${costcenter.number}`"
          exact
        >
          <v-list-item-content>
            <v-list-item-title>{{ costcenter.name }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense nav v-if="$keycloak.hasResourceRole('si', 'po-viewer')">
        <v-subheader>COMPTES</v-subheader>
        <v-list-item link :to="`/validations?account=3118010`" exact>
          <v-list-item-content>
            <v-list-item-title>Compte 3118010</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link :to="`/validations?account=3158010`" exact>
          <v-list-item-content>
            <v-list-item-title>Compte 3158010</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list dense nav v-if="$keycloak.hasResourceRole('ecg', 'po-viewer')">
        <v-subheader>CENTRE DE COÛT 42432</v-subheader>
        <v-list-item link to="/validations?costcenter=42432&account=3118010" exact>
          <v-list-item-content>
            <v-list-item-title>Compte 3118010</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/validations?costcenter=42432&account=3113020" exact>
          <v-list-item-content>
            <v-list-item-title>Compte 3113020</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link to="/validations?costcenter=42432&account=3158010" exact>
          <v-list-item-content>
            <v-list-item-title>Compte 3158010</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list
        dense
        nav
        v-if="$keycloak.hasResourceRole('communication', 'po-viewer')"
      >
        <v-subheader>SERVICE COMMUNICATION</v-subheader>
        <v-list-item
          link
          to="/service-communication/validations?status=to-update&type=validation"
          exact
        >
          <v-list-item-icon>
            <v-icon>mdi-timeline-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>À modifier</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          to="/service-communication/orders?status=processing"
          exact
        >
          <v-list-item-icon>
            <v-icon>mdi-timeline-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>En cours de validation</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          link
          to="/service-communication/orders?status=to-order"
          exact
        >
          <v-list-item-icon>
            <v-icon>mdi-timeline-check-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>À commander</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          to="/service-communication/orders?status=archive"
          exact
        >
          <v-list-item-icon>
            <v-icon>mdi-file-document-multiple-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Historique</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main>
      <router-view :costcentersList="costcenters" />
    </v-main>
  </v-app>
</template>

<script>
import UserProfile from "@/components/UserProfile.vue";
import axios from "axios";
export default {
  data: () => ({ drawer: null, costcenters: [] }),
  components: { UserProfile },
  async mounted() {
    if (
      this.$keycloak.hasResourceRole("communication", "po-viewer") &&
      this.$route.path === "/"
    ) {
      this.$router.push("/service-communication");
    }
    if (
      this.$keycloak.hasResourceRole("ecg", "po-viewer") &&
      this.$route.path === "/"
    ) {
      this.$router.push("/validations?costcenter=42432&account=3118010");
    }
    this._keyListener = function (e) {
      if (e.key === "k" && (e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        if (this.$route.path !== "/") {
          this.$router.push("/");
        }
      }
    };
    document.addEventListener("keydown", this._keyListener.bind(this));

    if (
      this.$keycloak.hasResourceRole("admin", "po-viewer") ||
      this.$keycloak.hasResourceRole("si", "po-viewer") ||
      this.$keycloak.hasResourceRole("ecg", "po-viewer")
    ) {
      try {
        const { data: costcenters } = await axios({
          method: "get",
          url: `${process.env.VUE_APP_API_URI}/costcenters`,
        });

        this.costcenters = costcenters.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      } catch (error) {
        console.log(error);
      }
    }
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this._keyListener);
  },
};
</script>
